export default {
    pickupStudentListUpdate : state => state.pickupStudentListUpdate,
    pickupRouteTimes:  state => state.pickupRouteTimes,
    pickupStudentTemplate:state => state.pickupStudentTemplate,
    isSavePickup: state => state.isSavePickup
}
